// extracted by mini-css-extract-plugin
export default {"flavors_title":"taa","no_selected_flavors":"uaa","success":"vaa","select_flavors_wrapper":"waa","flavors_select":"xaa","custom_select_control":"yaa","opened":"zaa","subtitle":"Aaa","selected_flavors":"Baa","selected_flavor_item":"Caa","selected_flavor_item_image":"Eaa","selected_flavor_item_title":"Faa","selected_flavor_item_qty":"Gaa","drawer_header":"Haa"};
    if(module.hot) {
      // 1737143665245
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  